import { useQuery } from 'react-query';

import { getRowDrillDownActivities as queryFn } from 'api/endPoints/getRowDrillDownActivities';

export const useQueryGetRowDrillDownActivities = (params) => {
    return useQuery({
        queryKey: ['getRowDrillDownActivities', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.checkId) && Boolean(params.columnAccessor) && Boolean(params.rowAccessor),
    });
};
